'use client';

import { c as _c } from "react/compiler-runtime";
import { useFetchGetSitePresetQuery } from '@module/queries/preset/presetQueryHooks';
import './ASPNewCustomFooter.scss';
function ASPNewCustomFooter() {
  const $ = _c(2);
  const {
    data: sitePreset
  } = useFetchGetSitePresetQuery();
  const t0 = sitePreset?.company.customCopyrightW ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = <footer id="asp-new-footer"><div dangerouslySetInnerHTML={{
        __html: t0
      }} /></footer>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default ASPNewCustomFooter;